<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
       <span
           class="main-r_top_nav"
           :class="mainStatus === 'online' && 'active'"
           @click.stop="handleClick('online')"
       >{{$t('apiDoc.在线文档')}}</span>
      <span
          class="main-r_top_nav"
          :class="mainStatus === 'apiTest' && 'active'"
          @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";
import apiTestDoc from "../components/apiTestDoc";
import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'bill/lading/cancelDeclaration';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.取消申报清关单，申报开始前支持取消')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        postDataList:[
          {
            title:'Headers',
            value:[
              {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`, },
              {name: "timestamp",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳')}`,},
              {name: "digest",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`, },
              {name: "digestType",type: "Number",require: "N",normal: "",describe: `${this.$t('onlineDoc.签名类型')}`, },
            ]
          },
          {
            title:`${this.$t('onlineDoc.请求参数')}`,
            value:[
              {name: "bizContent",type: "String",require: "Y",normal: '',describe: `${this.$t('onlineDoc.业务参数')}`,},
            ]
          },
          {
            title:`${this.$t('onlineDoc.业务参数')}`,
            value:[
              {name: "customerCode",type: "String",require: "Y", normal: "", describe:`${this.$t('onlineDoc.客户编码')}`},
              {name: "masterWaybillNo",type: "String",require: "Y", normal: "", describe:`${this.$t('onlineDoc.提单号')}`}
            ],
          }
        ],
        responseDataList:[
          {
            title:`${this.$t('onlineDoc.响应参数')}`,
            value:[
              { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码')}`,},
              {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
              {name: "data",type: "Object",require: "N",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
            ]
          }

        ],
        //请求示例
        requestCode: `Header：
     apiAccount=292508153084379141
     Content-Type=application/x-www-form-urlencoded
     digest=djEINdkT7aLeivrvhf91SQ==
     timestamp=1648536570679

 Body：
     bizContent = {"customerCode":"J0086024173","masterWaybillNo":"LDG2025684043747"}`,
        //返回示例
        responseCode: JSON.parse(`{"code":"1","msg":"success"}`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
        _headerData: {
          apiAccount: "292508153084379141",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data:{
          bizContent: `{"customerCode":"J0086024173","masterWaybillNo":"LDG2025684043747"}`,
        },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>